import React, { memo } from "react";
import { Handle, useStoreState, Position } from "react-flow-renderer";

import { EventEnd } from "./styles.js";
import Stop from "../../../assets/icons/Stop";

const EventEndNode = ({
  id,
  data,
  targetPosition = Position.Left,
  selected,
}) => {
  const edges = useStoreState((state) => state.edges);
  const nodes = useStoreState((state) => state.nodes);

  return (
    <EventEnd selected={selected} className="flow_elements_node" data-id={id}>
      <Stop style={{ height: "20px", width: "20px" }} />
      <Handle
        type="target"
        position={targetPosition}
        id="a"
        style={{ width: "8px", height: "8px" }}
        isValidConnection={(e) =>
          nodes.find((item) => item.id === e.source).type === "parallel" ||
          nodes.find((item) => item.id === e.source).type === "conditional"
            ? true
            : !edges.find(
                (item) => item.target === e.target || item.source === e.source
              )
        }
      />
    </EventEnd>
  );
};

export default memo(EventEndNode);
